import { KeyValuePair } from "../../KeyValuePair";
import { ActionType } from "./ActionType";
import { ScriptedVariable } from "../variable/ScriptedVariable";
import { FlowVariable } from "../variable/FlowVariable";
import { Variable } from "../variable/Variable";
import { Condition } from "../condition/Condition";
import { Ratelimit } from "./Action";

export enum ContentType {
  JSON = "application/json",
  XML = "application/xml",
  TEXT = "application/text",
  FORM_DATA = "multipart/form-data",
  X_WWW_FORM_URLENCODED = "application/x-www-form-urlencoded",
  RAW = "RAW",
}

export interface WebRequestAction {
  id?: string;
  parentId?: string;
  name?: string;
  description?: string;
  order?: number;
  enabled?: boolean;
  type: ActionType.WEB_REQUEST_ACTION_TYPE;
  iterator?: string;

  conditions?: Condition[];
  scriptedVariables?: ScriptedVariable[];
  variables?: Variable[];
  flowVariables?: FlowVariable[];
  body?: string;
  url?: string;
  method?: string;
  headers?: KeyValuePair[];
  credentialsReference?: CredentialsReference;
  uiRenderer?: string;
  pagination?: Pagination;
  ratelimit?: Ratelimit;
  responseFileConfig?: ResponseFileConfig;
  responseOpt?: ResponseOpt;
  mockResponseHeaders?: string;
  mockResponseData?: string;
  mockResponseEnabled?: boolean;
  contextLogAppender?: string;
}

export interface CredentialsReference {
  type: CredentialsReferenceType.NONE | CredentialsReferenceType.DATABASE_REF | CredentialsReferenceType.ATLASSIAN_TOKEN;
  value?: string;
}

export enum CredentialsReferenceType {
  DATABASE_REF = "DATABASE_REF",
  ATLASSIAN_TOKEN = "ATLASSIAN_TOKEN",
  NONE = "NONE",
}

export enum PaginationType {
  AUTO_INCREMENT = "AUTO_INCREMENT",
  URL_BASED = "URL_BASED",
  RESPONSE_BASED = "RESPONSE_BASED",
  CUSTOM = "CUSTOM",
}

export interface Pagination {
  enabled: boolean;
  breakJsonPath: string;
  type?: PaginationType.AUTO_INCREMENT | PaginationType.RESPONSE_BASED | PaginationType.URL_BASED | PaginationType.CUSTOM;
  variable: ScriptedVariable;
}

export interface ResponseFileConfig {
  enabled: boolean;
  fileNameTemplate?: string;
  contentTypeTemplate?: string;
  target?: ResponseFileTarget;
}

export enum ResponseFileTarget {
  INPUT_FILES = "INPUT_FILES",
}

type Transformation = { enabled: true; script: string } | { enabled: false };

export interface ResponseOpt {
  convertXmlToJson?: boolean;
  xsdSchemaUrl?: string;
  transformation?: Transformation;
}
